<template>
	<div v-loading="isTableLoading" class="ReportTable">
		<!-- !! Labour cost table -->
		<div v-if="isLabourDataShows && labourCostDataType == null">
			<div class="table-heading">
				<span>Labour {{isLabourDataShows == 'labour_hour' ? 'Hrs' : 'Cost'}} Report</span>
			</div>

			<div class="table-sns">
				<div>
					<slot name="headingOfTable"> </slot>
				</div>
				<el-button :disabled="!labourData_store.length >= 1" class="btn cancel-btn ml-4 px-2 py-5" size="mini" plain @click="downloadCsvReport(labourCostData, 'labourCostData')">
					CSV <i class="el-icon-download"></i>
				</el-button>
			</div>

			<div class="scroll">
				<table v-if="labourCostData.length" class="reportTable">
					<thead>
						<tr>
							<th>Store Name</th>
							<template v-if="isLabourDataShows == 'labour_cost'">
								<th>Store Sales</th>
								<th>Scheduled Labour Cost</th>
								<th>Actual Labour Cost</th>
								<th>Scheduled COL (%)</th>
								<th>Actual COL (%)</th>
							</template> 
							<template v-if="isLabourDataShows == 'labour_hour'">
								<th>Scheduled Hrs</th>
								<th>Actual Hrs</th>
								<th>VTS</th>
							</template> 
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item_col, index) in labourCostColData" :key="'labour-cost-col-data-'+index"
							class="lbr-table-col-header">
							<td>Consolidated</td>
							<template v-if="isLabourDataShows == 'labour_cost'">
								<td>{{item_col.actual_sales}}</td>
								<td>{{item_col.scheduled_lc}}</td>
								<td>{{item_col.actual_lc}}</td>
								<td>{{item_col.sch_lc_act_sales_percentage}}</td>
								<td>{{item_col.actual_lc_percentage}}</td>
							</template> 
							<template v-if="isLabourDataShows == 'labour_hour'">
								<td>{{item_col.scheduled_hours}}</td>
								<td>{{item_col.actual_hours}}</td>
								<td>{{item_col.vts}}</td>
							</template> 
						</tr>
						<tr v-for="(item, index) in labourCostData" :key="'labour-cost-data-'+index"
							class="lbr-table-header">
							<td style="color: #2c9bce !important; font-weight: 700;">{{item.name}}</td>
							<template v-if="isLabourDataShows == 'labour_cost'">
								<td>{{item.actual_sales}}</td>
								<td>{{item.scheduled_lc}}</td>
								<td>{{item.actual_lc}}</td>
								<td>{{item.sch_lc_act_sales_percentage}}</td>
								<td>{{item.actual_lc_percentage}}</td>
							</template>

							<template v-if="isLabourDataShows == 'labour_hour'">
								<td>{{item.scheduled_hours}}</td>
								<td>{{item.actual_hours}}</td>
								<td>{{item.vts}}</td>
							</template> 
							
						</tr>
					</tbody>
				</table>
			</div> 

			<div style="text-align:center;" class="" v-if="!labourCostData.length">
				<el-empty style="padding: 2px 0 35px 0 !important;" description="No Data Found!"></el-empty> 
			</div>
			<!-- Pagination for labour cost -->
			<div v-if="labourData_store.length"  class="text-right">
				<div class="pagination p-4 pt-0 text-right">
					<el-pagination background layout="prev, pager, next" :total="labourCostData.length"
						:current-page.sync="currentPage" :page-size="showLabourCostDataCount">
					</el-pagination>
				</div>
			</div>
		</div>


		<!-- !! Daily weekly and monthly table -->
		<div v-if="isLabourDataShows && ['monthly' , 'daily' , 'weekly'].includes(labourCostDataType)">
			<div class="table-heading">
				<span>Labour {{isLabourDataShows == 'labour_hour' ? 'Hrs' : 'Cost'}} Report</span>
			</div>
			<div class="table-sns">
				<div>
					<slot name="headingOfTable"> </slot>
				</div>
				<el-button class="btn cancel-btn ml-4 px-2 py-5" size="mini" plain @click="downloadCsvReport(labourCostData, 'labourCostData')">
					CSV <i class="el-icon-download"></i>
				</el-button>
			</div>
			<div class="scroll">
				<table v-if="labourData_store.length" class="reportTable" style="margin-left: 248px;">
					<thead> 
						<tr>
							<th :colspan="isLabourDataShows == 'labour_hour' ? 3 : 2" v-for="(date, index) in labourCostData.headings" style="min-width: 252px; background-color: #f2f2f2; border-right: 2px solid #ddd" :key="'labour-cost-col-data-date'+index" :class="date.value == 'Store Name' ? 'headcol' : ''" class="-ml-1 px-10">
								{{ date.value }} 
							</th>
						</tr>
						<tr>
							<th style="min-width: 252px; background-color: #f2f2f2;"  class="headcol -ml-1 bt-none"> &nbsp; </th>
							 <th :class="((sub_head == 'Actual' && isLabourDataShows == 'labour_cost') || (sub_head == 'VTS' && isLabourDataShows == 'labour_hour')) ? 'border-rit' : '' " style="padding-left: 35px !important; padding-right: 35px !important;" v-for="(sub_head, index_d_2) in labourCostData.subHeading" :key="index_d_2">
								 {{sub_head}}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in labourCostData.row" :key="'labour-cost-store-name-'+index" class="lbr-table-header"
							:class="item.store == 'Consolidated' ? 'font-bold' : ''">
							<td style=" font-weight: 700; margin-right: 250px;" :style="{ 'color':
															item.store == 'Consolidated' ? '#000' : ' #2c9bce'
													}" class="headcol bg-white -ml-1">{{item.store}}</td>
							<template v-for="(data, data_index) in item.value">
								<td style="padding-left: 35px !important;" :key="'labour-cost-col-data2-'+data_index">{{ verifyNData(data.scheduled_lc) }}</td>
								<td :style="{'border-right' : isLabourDataShows == 'labour_cost' ? '2px solid #ddd' : ''}" :key="'labour-cost-col-data3-'+data_index">{{ verifyNData(data.actual_lc) }}</td>
								<td :style="{'border-right' : isLabourDataShows == 'labour_hour' ? '2px solid #ddd' : ''}" style="padding-right: 35px !important; border-right: 2px solid #ddd"  v-if="isLabourDataShows == 'labour_hour'" :key="'labour-cost-col-data4-'+data_index">{{ verifyNData(data.vts) }}</td>
							</template>
						</tr>
					</tbody>
				</table>
			</div> 
			<div style="text-align:center;" class="" v-if="!labourData_store.length">
				<el-empty style="padding: 2px 0 35px 0 !important;" description="No Data Found!"></el-empty> 
			</div>
			<!-- Pagination for labour cost -->
			<div v-if="labourData_store.length" class="text-right">
				<div class="pagination p-4 pt-0 text-right">
					<el-pagination background layout="prev, pager, next" :total="labourCostStoreName.length"
						:current-page.sync="currentPage" :page-size="showLabourCostDataCount">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- Other Reports are started from here -->
		<div  v-if="!isLabourDataShows">
			<div class="table-heading">
				<slot v-if="quickReports == 'wfr'" name="headingOfTable">
					<span>Workforce Report</span>
					<span> - </span>
					<span v-if="quickReportLabel == 'iplh'">Items Per Labour Hour (IPLH)</span>
					<span v-if="quickReportLabel == 'variance'">Variance</span>
					<span v-if="quickReportLabel == 'shift_complement'">Shift Complement</span>
					<span v-if="quickReportLabel == 'tplh'">Transactions Per Labour Hour (TPLH)</span>
				</slot>
				<slot v-else name="headingOfTable">
					<span v-if="quickReports == 'day'">Daily</span>
					<span v-if="quickReports == 'week'">Weekly</span>
					<span v-if="quickReports == 'month'">Monthly</span>
					<span> - </span>
					<span v-if="quickReportLabel == 'iplh'">Items Per Labour Hour (IPLH)</span>
					<span v-if="quickReportLabel == 'tplh'">Transactions Per Labour Hour (TPLH)</span>
					<span v-if="quickReportLabel == 'variance'">Variance</span>
					<span v-if="quickReportLabel == 'manpower'">Manpower</span>
					<span v-if="quickReportLabel == 'labour_hours'"> Labour Hours </span>
				</slot>
			</div>
			<div class="flex justify-between items-center">
				<div class="pl-8">
					<span :class="[
						breadCrumbs.length > 0
							? 'cursor-pointer text-black capitalize text-sm hover:text-orange-dark'
							: 'text-grey-dark text-sm capitalize'
					]" @click="defaultBreadcurmbClicked()">{{ $route.name }}
						<i class="el-icon-arrow-right" style="font-size: 15px;vertical-align: text-bottom;"></i>
					</span>
					<span v-for="(bread_curmb, index) in breadCrumbs" :key="index">
						<span v-for="(key, value, obj_index) in bread_curmb" :key="obj_index">
							<span :class="[
								value == active_breadCrumbs
									? 'text-grey-dark text-sm capitalize'
									: 'cursor-pointer text-black capitalize text-sm hover:text-orange-dark'
							]" @click="breadCurmbClicked(value, key)">
								{{ value }}
							</span>
							<span v-if="index != breadCrumbs.length - 1">
								<i class="el-icon-arrow-right" style="font-size: 15px;vertical-align: text-bottom;"></i>
								&nbsp;
							</span>
						</span>
					</span>
				</div>
				<div class="table-sns">
					<div>
						<slot name="headingOfTable"> </slot>
					</div>
					<el-button class="btn cancel-btn ml-4 px-2 py-5" size="mini" plain @click="downloadCsvReport(tableData, 'tableData')" >
						CSV <i class="el-icon-download"></i>
					</el-button>
				</div>
			</div> 
			<div class="scroll">
				<table v-if="tableData.data" class="reportTable" :style="[ ['monthly' , 'daily' , 'weekly'].includes(labourCostDataType) ? {marginLeft: '248px'} : '' ]" >
					<thead>
						<tr> 
							<th v-for="(mainHeading, index) in tableData.data.mainHeadings" :key="index"
								:colspan="mainHeading.colspan" :class="['monthly' , 'daily' , 'weekly'].includes(labourCostDataType) && !mainHeading.value  ? 'headcol' : ''"
								:style="[
									['monthly' , 'daily' , 'weekly'].includes(labourCostDataType) && !mainHeading.value ? {backgroundColor: '#f2f2f2', minWidth: '250px', paddingBottom: '25px'} : ''
								]"
								>
								<div :class="{
									'mainHeadings-border-bottom':
										mainHeading.isBorderBottomRequired
								}">
									{{ mainHeading.value ? mainHeading.value : '&nbsp;' }}
								</div>
							</th>
						</tr>
						<tr style="border-top: 1px solid #ddd;">
							<th v-for="(subHeading, index) in tableData.data.subHeadings" :key="index" :class="['monthly' , 'daily' , 'weekly'].includes(labourCostDataType) && subHeading.value == 'Store Name' ? 'headcol' : ''"   
						:style="[
								['monthly' , 'daily' , 'weekly'].includes(labourCostDataType) && subHeading.value !== 'Store Name'
									? { minWidth: '100px' }
									: null,
									['monthly' , 'daily' , 'weekly'].includes(labourCostDataType) && subHeading.value == 'Store Name' ? {backgroundColor: '#f2f2f2', minWidth: '250px'} : ''
							]"
							>
								{{ subHeading.value }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(data, index) in tableData.data.tableRows" :key="index" :style="{
							'font-weight': index == 0 ? 'bold' : ''
						}">
							<td style="color: #b99edf; text-transform: capitalize;" :class="['monthly' , 'daily' , 'weekly'].includes(labourCostDataType) ? 'headcol bg-white' : ''" >
								<template>
									<slot name="button" :element="data" :indexOfRow="index"></slot>
								</template>
							</td>
							<td v-for="(item, index1) in data.data" :key="index1">
								{{ item }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="text-right">
				<div class="pagination p-4 pt-0 text-right">
					<el-pagination background :current-page.sync="pageInfo.currentPage" :page-sizes="[5, 10, 15]"
						:page-size.sync="pageInfo.pageSize" layout="sizes, prev, pager, next" :total="tablePageCount"
						@size-change="handlePageInfoChange" @current-change="handlePageInfoChange" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "../../../../eventBus";
import Papa from "papaparse";

export default {
	props: {
		tableData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			showLabourCostDataCount: 10,
			noOfEntries: 10,
			currentPage: 1,
			pageSize: 10,
			pageInfo: {
				currentPage: 1,
				pageSize: 10
			},
			breadCrumbs: [],
			active_breadCrumbs: "",
			disabled: false
		};
	},
	computed: {
		...mapState("CommonStore", ["tablePageCount", "reportLoader", "labourData_store", "isLabourDataSHow", "labourColData_store", "quickReportLabel", "labourCostDataType", "labourHourData_store", "labourColHourData_store"]),
		quickReports() {
			return this.$store.getters.getQuickReports;
		},
		selectedView() {
			return this.$store.getters.getselectSalesView;
		},
		isLabourDataShows() {
			return this.isLabourDataSHow;
		},
		isTableLoading() {
			return this.reportLoader;
		},
		labourCostData() {
			let data = this.labourData_store; 
			if(['monthly' , 'daily' , 'weekly'].includes(this.labourCostDataType)){
				return this.refactorLabourData(data);
			}
			return data;
		},
		labourCostStoreName() {
			let data = this.labourData_store;
			let result = []
			data.map((elm)=>{
				result.push(elm.name);
			});
			result = _.uniq(result);
			return result;
		},
		labourCostDate() {
			let data = this.labourData_store;
			let result = []
			data.map((elm)=>{
				result.push(elm.for_date);
			});
			result = _.uniq(result);
			return result;
		},
		labourCostColData() {
			let data = this.labourColData_store;
			return data;
		},
		currentIndex() {
			let index = 0;

			let total_records = this.labourCostData.length;

			let total_pages = (total_records / this.showLabourCostDataCount);
			if (total_pages) {
				total_pages = total_pages.toFixed();
			}

			if (this.currentPage > 1) {
				index = this.currentPage - 1;
			}

			return index;
		},
		startNumber() {
			let start = (this.currentPage * this.showLabourCostDataCount) - (this.showLabourCostDataCount - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(this.startNumber + this.showLabourCostDataCount - 1, this.labourCostData.length);
			return end;
		},
	},
	mounted() {
		EventBus.$on("resetPageInfoEvent", this.handleResetPageInfoEvent);
		EventBus.$on("disableFirstButton", payload => {
			this.disabled = payload;
		});
		EventBus.$on("breadCrumbs", data => {
			this.breadCrumbs = data;
		});
		EventBus.$on("activeBreadCrumb", data => {
			this.active_breadCrumbs = data;
		});
	},
	beforeDestroy() {
		EventBus.$off("resetPageInfoEvent", this.handleResetPageInfoEvent);
		EventBus.$off("disableFirstButton");
	},
	methods: {
		// downloadCsvReport() {
		// 	// this.downloadCsv(this.tableData);
		// 	EventBus.$emit("downloadCsvReport");
		// },
		verifyNData(data){
			if(data !== null) { return data; } else { return ' ' }
		},
		refactorLabourData(data){
			let tempObj = {headingMain: [], headings:[{ value: "Store Name" }], subHeading:[], row:[]}  
				
				// Added Store name here
				let tempArr = [];
				this.labourCostStoreName.map((elm)=>{
					const arr2 = {store:elm, value:[]};
					tempArr.push(arr2);
				});
				tempObj.row = tempArr;

				// For consolidated
				let colData = {store: 'Consolidated', value: []} 
				tempObj.row.unshift(colData);

				// Added heading here and then date
				let date = 	[...this.labourCostDate]
				date.map((e_date)=>{
					tempObj.headings.push({value:e_date});
					// add subheadings 
					if(this.isLabourDataShows == 'labour_hour') {
						tempObj.subHeading.push("Scheduled","Actual", "VTS");
					}else  {
						tempObj.subHeading.push("Scheduled","Actual");
					}
					// add date into row
					tempObj.row.map((r_data)=>{
						r_data.value.push({date:e_date, scheduled_lc: null, actual_lc: null, vts: null});
					});
				});

				// Here we can filter and add date and store wise data
				data.map((e_val)=>{
					tempObj.row.map((str)=>{
						if(e_val.name == str.store) {
							str.value.map((val)=>{
								if(val.date == e_val.for_date && this.isLabourDataShows == 'labour_cost') {
									val.actual_lc = e_val.actual_lc ? e_val.actual_lc : 0;
									val.scheduled_lc = e_val.scheduled_lc ? e_val.scheduled_lc : 0; 
								} else if(val.date == e_val.for_date && this.isLabourDataShows == 'labour_hour') {
									val.actual_lc = e_val.actual_hours ? e_val.actual_hours : 0;
									val.scheduled_lc = e_val.scheduled_hours ? e_val.scheduled_hours : 0; 
									val.vts = e_val.vts ? e_val.vts : 0;
								}
							})
						}
					})
				});

				// For consolidated data 
			this.labourColData_store.map((e_val) => {
				tempObj.row.map((str) => {
					if (e_val.name === 1 && str.store == 'Consolidated') {
						str.value.map((val) => {
							if (val.date == e_val.for_date && this.isLabourDataShows == 'labour_cost') {
								val.actual_lc = e_val.actual_lc ? e_val.actual_lc : 0;
								val.scheduled_lc = e_val.scheduled_lc ? e_val.scheduled_lc : 0;
							} else if (val.date == e_val.for_date && this.isLabourDataShows == 'labour_hour') {
								val.actual_lc = e_val.actual_hours ? e_val.actual_hours : 0;
								val.scheduled_lc = e_val.scheduled_hours ? e_val.scheduled_hours : 0;
								val.vts = e_val.vts ? e_val.vts : 0;
							}
						})
					}
				})
			});

				return data = tempObj;
		},
		createCsvJson(tableData) {
			var headings = tableData.data.headings;
			var subHeadings = tableData.data.subHeadings;
			var mainHeadings = tableData.data.mainHeadings;
			var csvSubHeadings = tableData.data.csvSubHeadings;
			if (tableData.data.headings.length) {
				var result = tableData.data.rows.map(row => {
					var mappedArray = row.map((element, count) => {
						return {
							[headings[count] && headings[count].value]: element.value
						};
					});
					var obj = {};
					mappedArray.map((el, i) => {
						obj[[headings[i].value]] = el[headings[i].value];
					});
					return obj;
				});
				return result;
			} else {
				let name = tableData.data.subHeadings[0].value;
				var result = tableData.data.tableRows.map(ele => {
					let obj = {};
					obj[name] = ele.label;
					ele.data.map((el, index) => {
						if (this.quickReports != "wfr") {
							obj[subHeadings[index + 1].value] = el;
						} else {
							let key = "";
							key = csvSubHeadings[index + 1].value;
							obj[key] = el;
						}
						return obj;
					});
					return obj;
				});
				return result;
			}
		},
		generateCsvJson(tableData){
			let tempData = []
			var isDWM = ['monthly' , 'daily' , 'weekly'].includes(this.labourCostDataType);

			if(isDWM) {
				tableData = this.labourData_store;
			}
			 if(this.isLabourDataShows == 'labour_cost') {
				tableData.map((e)=>{
					const obj = { 
						Date: [],
						Store_Name: e.name,
						Sales: e.actual_sales,
						Scheduled_Labour_Cost : e.scheduled_lc,
						Actual_Labour_Cost : e.actual_lc,
						Scheduled_COL : e.sch_lc_act_sales_percentage,
						Actual_COL : e.actual_lc_percentage,
					}
					if(isDWM) { obj.Date = e.for_date } else {delete obj.Date}
					tempData.push(obj)
				})
			 } else if(this.isLabourDataShows == 'labour_hour') {
				if(isDWM) {
					tableData = this.labourData_store;
				}
				tableData.map((e)=>{
					const obj = {
						Date: [],
						Store_Name: e.name,
						Scheduled_Hrs : e.scheduled_hours,
						Actual_Hrs: e.actual_hours,
						VTS : e.vts,
					}
					if(isDWM) { obj.Date = e.for_date } else {delete obj.Date}
					tempData.push(obj)
				})
			 } 
			return tempData;
		},
		downloadCsvReport(tableData, which) {

			var export_csv = which == 'tableData' ? this.createCsvJson(tableData) : this.generateCsvJson(tableData);
			// *****************download csv file************************************
			var csv = Papa.unparse(export_csv);
			var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });

			var csvURL = null;
			if (navigator.msSaveBlob) {
				csvURL = navigator.msSaveBlob(csvData, "download.csv");
			} else {
				csvURL = window.URL.createObjectURL(csvData);
			}

			var tempLink = document.createElement("a");
			tempLink.href = csvURL;
			// tempLink.setAttribute("download", "download.csv");
			if (this.quickReports == "wfr") {
				tempLink.setAttribute(
					"download",
					`Workforce Report ${localStorage.getItem("dateRange")}.csv`
				);
				tempLink.click();
			} else {
				tempLink.setAttribute(
					"download",
					`${this.quickReports} Repot ${localStorage.getItem("dateRange")} .csv`
				);
				tempLink.click();
			}
		},

		handleResetPageInfoEvent() {
			// console.log("resetting pageInfo");
			this.pageInfo.currentPage = 1;
			this.pageInfo.pageSize = 10;
		},
		handlePageInfoChange(val) {
			const routeName = this.$route.name;
			if (
				// if current page is greater than total pages then make the current page to the the last page.
				this.pageInfo.currentPage >
				this.tablePageCount / this.pageInfo.pageSize
			) {
				this.pageInfo.currentPage = Math.ceil(
					this.tablePageCount / this.pageInfo.pageSize
				);
			}
			this.pageInfo.currentPage == 0
				? (this.pageInfo.currentPage = 1)
				: (this.pageInfo.currentPage = this.pageInfo.currentPage);
			this.$emit("changePageNo", this.pageInfo);
			console.log("val", val, this.tablePageCount);
			// EventBus.$emit("pageInfoChangeReport", this.pageInfo);
		},
		// handleCurrentChange(val) {
		// 	const routeName = this.$route.name;
		// 	if (routeName == "forecastLocation" || routeName == "forecastCategory") {
		// 		EventBus.$emit("currentPageChangeForecastEvent", this.currentPage);
		// 	}
		// 	if (routeName == "Location" || routeName == "Category") {
		// 		EventBus.$emit("currentPageChangeSalesEvent", this.currentPage);
		// 	}
		// },
		breadCurmbClicked(selected_bredcrumb, element) {
			EventBus.$emit("activeBreadCrumb", selected_bredcrumb);
			const routeName = this.$route.name;
			EventBus.$emit("clickBreadcurmbReportEvent", selected_bredcrumb, element);
		},
		defaultBreadcurmbClicked() {
			// this.$router.go(-1);
			EventBus.$emit("clickToShowInitialReportData");
		}
	}
};
</script>

<style scoped lang="scss">
@import "./ReportTable.scss";

::-webkit-scrollbar-track {
	background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
	background: #c1c1c1;
}

::-webkit-scrollbar {
	height: 8px;
	overflow: visible;
	width: 8px;
}

.ReportTable {
	thead {
		background: #f2f2f2;

		th {
			font: 700 13px/13px Avenir, Helvetica, Arial, sans-serif !important;
			color: #707070;
			text-transform: uppercase;
		}
	}

	td {
		font-size: 14px;
		padding: 12px 10px;
	}
}
</style>
<style lang="scss">
.AppLayout .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #f7ba89;
}

.AppLayout .el-pagination.is-background .el-pager li:not(.disabled):hover {
	color: #000;
}

.AppLayout .el-pagination .btn-next,
.AppLayout .el-pagination .btn-prev {
	border-radius: 50% !important;
}

.AppLayout .el-pager li {
	border-radius: 50% !important;
}

.mainHeadings-border-bottom {
	border-bottom: 3px solid #ddd;
	padding-bottom: 10px;
}

// .scoll ::-webkit-scrollbar {
// 	width: 8px;
// }
.lbr-table-header td {
	text-transform: capitalize;
	// font-weight: 700;  
}

.lbr-table-col-header td {
	text-transform: capitalize;
	font-weight: 700;
}
.headcol {
	position: absolute;
    width: 18em;
    left: 93px;
    top: auto;
    border-top-width: 1px;
    margin-top: -1px;
    padding: 11px;
    font-size: 14px;
	border-right: 1px solid #ddd;
}
.headcol-2 {
	position: absolute;
    width: 18em;
    left: 93px;
    top: auto;
    border-top-width: 1px;
    margin-top: -1px;
    padding: 11px;
    font-size: 14px;
	border-right: 1px solid #ddd;
}

.border-rit {
	border-right: 2px solid #ddd;
}
.table-sns .cancel-btn {
	color: #409eff;
    background: #ecf5ff;
    border-color: #b3d8ff;
	min-width: 70px;
	padding: 9px 15px!important;
	font-size: 12px;
    border-radius: 3px;
}
.table-sns .cancel-btn:hover {
	background: #409eff;
    border-color: #409eff;
    color: #fff;
}


</style>
